module.exports = __webpack_public_path__ + "img/square-l.fc211771.svg";